import React, { useEffect } from 'react';
import { useBreadcrumbs } from '../../contexts/breadcrumbsContext';
import { useLoading } from '../../contexts/loadingContext';
import { useTranslation } from '../../contexts/translation';
import { CustomersProjectsForm } from '../../forms/customersProjects/CustomersProjectsForm';
import { PageContentWrapper } from '../../layouts/contentWrapper/PageContentWrapper';
import { CustomerInputs } from '../../types/customer.types';

export function CustomersProjectsNew() {
  const { translate } = useTranslation();
  const transFormName = 'CustomersProjects.Create';
  const { startLoading, stopLoading } = useLoading();
  const { setValue } = useBreadcrumbs();

  useEffect(() => {
    setValue({
      pageName: 'New customer project',
      steps: [
        { name: 'Home', pathToCutCount: 3 },
        { name: 'Customers projects', pathToCutCount: 2 },
      ],
    });
    return () => {
      setValue(null);
    };
  }, []);

  const formData: CustomerInputs = {
    id: 0,
    name: '',
    visible: true,
  };

  return (
    <PageContentWrapper heading={translate!('New customer project', transFormName)}>
      <CustomersProjectsForm onSubmit={() => undefined} formData={formData} />
    </PageContentWrapper>
  );
}

export default CustomersProjectsNew;
